import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/products';
import './Shop.css';

const Shop = ({ onAddToCart }) => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  // Get unique categories
  const categories = ['All', ...new Set(products.map(product => product.category))];

  // Filter products based on category and search term
  const filteredProducts = products.filter(product => {
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    const matchesSearch = product.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="shop-page">
      <div className="shop-hero section">
        <div className="container">
          <div className="section-title">
            <h5>Our Products</h5>
            <h2>Eco-Friendly Car Care Solutions</h2>
            <p>Discover our range of innovative, waterless car cleaning products designed to protect your vehicle and the environment.</p>
          </div>
        </div>
      </div>

      <div className="shop-content section">
        <div className="container">
          {/* Filters */}
          <div className="shop-filters">
            <div className="search-filter">
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            <div className="category-filter">
              {categories.map(category => (
                <button
                  key={category}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Products Grid */}
          <div className="products-grid">
            {filteredProducts.length > 0 ? (
              filteredProducts.map(product => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    <img src= {`/${product.image}`} alt={product.title} />
                  </div>
                  <div className="product-info">
                    <div className="product-category">{product.category}</div>
                    <div className="shop-product-title" title={product.title}>{product.title}</div>
                    <div className="product-brand">by {product.brand}</div>
                    {/* <div className="product-description">{product.description}</div> */}
                    {/* <div className="product-price">OMR {product.price}</div> */}
                    <div className="product-actions">
                      {/* <button className="btn btn-primary" onClick={() => onAddToCart(product)}>
                        <i className="fas fa-shopping-cart"></i> Add to Cart
                      </button> */}
                      <Link to={`/product/${product.id}`} className="btn btn-outline">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-products">
                <h3>No products found</h3>
                <p>Try adjusting your search or filter criteria.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shop; 